<div class='row'>
  @if (applicant?.pesel; as pesel) {
    <div class="col-md-4">
      <app-label label='Numer PESEL:'>
        {{ pesel || '-' }}
      </app-label>
    </div>
  }
  @if (applicant?.nip; as nip) {
    <div class="col-md-4">
      <app-label label='Numer NIP:'>
        {{ nip || '-' }}
      </app-label>
    </div>
  }
  @if (applicant?.regon; as regon) {
    <div class="col-md-4">
      <app-label label='Identyfikator REGON:'>
        {{ regon || '-' }}
      </app-label>
    </div>
  }
  <div class='col-md-4'>
    <app-label label='Numer telefonu:'>
      {{ applicant?.phoneNumber || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Numer telefonu2:'>
      {{ applicant?.phoneNumber2 || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='E-mail:'>
      {{ applicant?.email || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Kod pocztowy:'>
      {{ applicant?.postalCode || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Poczta:'>
      {{ applicant?.postOffice || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Miejscowość:'>
      {{ applicant?.city || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Ulica:'>
      {{ applicant?.street || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Nr domu:'>
      {{ applicant?.houseNumber || '-' }}
    </app-label>
    @if (applicant?.apartmentNumber; as apartmentNumber) {
      &nbsp;<app-label label='Nr mieszkania:'>
        {{ applicant?.apartmentNumber || '-' }}
      </app-label>
    }
  </div>
</div>
